<template>
    <div>
        <btn v-if="is_active && Number(cost)"
            cssClass="btn btn-default" 
            icon="fas fa-dollar-sign" 
            style="color: green" 
            :title="money(cost)"
            :click="() => show = true"
        ></btn>

        <btn v-else-if="is_active"
            cssClass="btn btn-default" 
            icon="fas fa-dollar-sign" 
            style="color: orange" 
            :title="money(cost)"
            :click="() => show = true"
        ></btn>

        <btn v-else
            cssClass="btn btn-default" 
            icon="fas fa-ban" 
            style="color: gray" 
            title="Not counted in statistics"
            :click="() => show = true"
        ></btn>
    
        <el-dialog :title="dialogTitle"
            :visible.sync="show"
            :close-on-click-modal="false"
        >
            <div>
                <p class="mb-1">Reason:</p>

                <el-input
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 10 }"
                    v-model="form_data.reason">
                </el-input>
            </div>

            <span slot="footer" class="dialog-footer">
                <btn cssClass="btn btn-default" icon="fas fa-times" :click="() => show = false">Close</btn>

                <btn 
                    v-if="is_active" 
                    cssClass="btn btn-danger ml-2" 
                    icon="fas fa-dollar-sign" 
                    :click="() => setBudgetHidden()"
                >
                    Don't charge
                </btn>
                <btn 
                    v-else 
                    cssClass="btn btn-danger ml-2" 
                    icon="fas fa-dollar-sign" 
                    :click="() => unsetBudgetHidden()"
                >
                    Charge
                </btn>
            </span>
        </el-dialog> 
    </div>
</template>

<script>
    export default {
        props: [
            'employer_name',
            'delivery_lead_id',
            'cost',
            'is_active',
        ],
        data() {
            return {
                form_data: {
                    reason: null,
                },
                show: false,
            };
        },
        computed: {
            dialogTitle() {
                if(this.is_active) {
                    return `Don't charge for ATS sent to ${this.employer_name}`;
                }

                return `Charge for ATS sent to ${this.employer_name}`;
            },
        },
        methods: {
            reset() {
                this.show = false;
                this.form_data.reason = null;
            },
            setBudgetHidden() {
                return axios.post( url(`admin/delivery-lead/${this.delivery_lead_id}/set-budget-hidden`), this.form_data)
                    .then(() => {
                        this.reset();

                        this.$emit('updated', false);
                    });
            },
            unsetBudgetHidden() {
                return axios.post( url(`admin/delivery-lead/${this.delivery_lead_id}/unset-budget-hidden`), this.form_data)
                    .then(() => {
                        this.reset();

                        this.$emit('updated', true);
                    });
            },
        },
    };
</script>
